var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable, computedFrom, autoinject, transient } from "aurelia-framework";
import { StatusReasonClientService } from "../../../services/status-reason/status-reason-client.service";
import * as Enumerable from "linq";
var StatusReasonControl = /** @class */ (function () {
    function StatusReasonControl(statusReasonClienttService) {
        this.statusReasonClienttService = statusReasonClienttService;
        this._countPromise = 0;
        this.statuses = [];
        this.statusReasonsByStatusId = {};
        this.statusLabel = "Status";
        this.statusReasonLabel = "Status Reason";
    }
    Object.defineProperty(StatusReasonControl.prototype, "statusReasonParameters", {
        get: function () {
            return (this.statusId ? this.statusId : null) + "," + (this.committedStatusReasonId ? this.committedStatusReasonId : null);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StatusReasonControl.prototype, "statusParameters", {
        get: function () {
            return (this.entityTypeId ? this.entityTypeId : null) + ",0," + (this.committedStatusReasonId ? this.committedStatusReasonId : null);
        },
        enumerable: false,
        configurable: true
    });
    StatusReasonControl.prototype.bind = function () {
        if (this.entityTypeId) {
            this.loadAvailableTransitions();
        }
    };
    StatusReasonControl.prototype.committedStatusReasonIdChanged = function () {
        if (this.entityTypeId) {
            this.loadAvailableTransitions();
        }
    };
    StatusReasonControl.prototype.entityTypeIdChanged = function () {
        this.loadAvailableTransitions();
    };
    StatusReasonControl.prototype.loadAvailableTransitions = function () {
        var _this = this;
        this._countPromise += 1;
        var localCount = this._countPromise;
        this.statusReasonClienttService.getAvailableStatusReasonTransitions(this.committedStatusReasonId, this.entityTypeId).then(function (response) {
            if (localCount != _this._countPromise) {
                return;
            }
            var transitions = response.statusReasonTransitions;
            _this.statuses = Enumerable.from(transitions).selectMany(function (x) { return [x.nextStatusReason.status]; }).where(function (x) { return x != null; })
                .distinct(function (x) { return x.statusId; }).toArray();
            _this.statusReasonsByStatusId = Enumerable.from(transitions).groupBy(function (x) { return x.nextStatusReason.statusId; }).toObject(function (x) { return x.key(); }, function (x) { return x.select(function (z) { return z.nextStatusReason; }).distinct(function (x) { return x.statusReasonId; }).toArray(); });
            if (response.committedStatusReason && !_this.statuses.some(function (x) { return x.statusId == response.committedStatusReason.statusId; })) {
                _this.statuses.unshift(response.committedStatusReason.status);
                _this.statusReasonsByStatusId[response.committedStatusReason.statusId] = [];
            }
            if (response.committedStatusReason) {
                if (!_this.statusReasonsByStatusId[response.committedStatusReason.statusId].some(function (x) { return x.statusReasonId == response.committedStatusReason.statusReasonId; })) {
                    _this.statusReasonsByStatusId[response.committedStatusReason.statusId].unshift(response.committedStatusReason);
                }
                _this.statusId = response.committedStatusReason.statusId;
            }
        });
    };
    StatusReasonControl.prototype.onNextStatusReason = function (statusReasonId) {
        if (statusReasonId && statusReasonId != this.committedStatusReasonId) {
            this.currentStatusReasonId = statusReasonId;
        }
        else if (statusReasonId == this.committedStatusReasonId) {
            this.currentStatusReasonId = null;
        }
    };
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], StatusReasonControl.prototype, "statusLabel", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], StatusReasonControl.prototype, "statusReasonLabel", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], StatusReasonControl.prototype, "committedStatusReasonId", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], StatusReasonControl.prototype, "currentStatusReasonId", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], StatusReasonControl.prototype, "entityTypeId", void 0);
    __decorate([
        computedFrom('statusId', 'currentStatusReasonId'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], StatusReasonControl.prototype, "statusReasonParameters", null);
    __decorate([
        computedFrom('entityTypeId', 'currentStatusReasonId'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], StatusReasonControl.prototype, "statusParameters", null);
    StatusReasonControl = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [StatusReasonClientService])
    ], StatusReasonControl);
    return StatusReasonControl;
}());
export { StatusReasonControl };
